import React from 'react';
import { SliderControl } from 'components/commandpanel/ImageTuning/SliderControl';
import Histogram from '../wellImage/histogram';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';

interface Props {
  lowerLevelLimit: number;
  upperLevelLimit: number;
  isAutoLevelingOn: boolean;
  wellImage: string;
  setTuningValues: (params: number[]) => void;
  saveTuningValues: (params: number[]) => void;
  onMinValueChange: (e: any) => void;
  onMaxValueChange: (e: any) => void;
  onAutoClick: (e: any) => void;
  onResetClick: (e: any) => void;
}

const ImageTuning = (props: Props) => {
  const {
    lowerLevelLimit,
    upperLevelLimit,
    isAutoLevelingOn,
    wellImage,
    setTuningValues,
    saveTuningValues,
    onMinValueChange,
    onMaxValueChange,
    onAutoClick,
    onResetClick,
  } = props;

  return (
    <div id="imagetuning-main-container" className="flex flex-col items-center mx-2 mt-2">
      <div id="imagetuning-histogram-wrapper"
        className={
          isAutoLevelingOn ? 'opacity-50 pointer-events-none w-[95%]' : 'w-[95%]'
        }
      >
        <Histogram  image={wellImage} />
      </div>
      <div id="imagetuning-slider-wrapper"
        className={`w-[95%] ${isAutoLevelingOn ? 'opacity-50 pointer-events-none' : ''}`}
      >
        <SliderControl
          id="imagetuning-slidercontrol"
          disabled={isAutoLevelingOn}
          lowerLevelLimit={lowerLevelLimit || 0}
          upperLevelLimit={upperLevelLimit || 0}
          setSliderValues={setTuningValues}
          updateSliderValues={saveTuningValues}
        />
      </div>
      <div id="imagetuning-controls-container" className="!flex flex-row w-full justify-between">
        <div id="imagetuning-lowerlimit-container">
          <input
            id="imagetuning-input-lowerlimit"
            name="lowerLimit"
            type="number"
            value={lowerLevelLimit}
            onChange={onMinValueChange}
            className="w-14"
            disabled={isAutoLevelingOn}
          />
        </div>
        <div id="imagetuning-button-group" className="w-1/3 flex gap-2 justify-center items-center">
          <RMCustomButton
            title="AUTO"
            contentContainerClass="advButtonStyle"
            onClick={onAutoClick}
            isDisabled={isAutoLevelingOn}
          />
          <RMCustomButton
            title="RESET"
            contentContainerClass="advButtonStyle"
            onClick={onResetClick}
            isDisabled={false}
          />
        </div>
        <div id="imagetuning-upperlimit-container">
          <input
            id="imagetuning-input-upperlimit"
            name="upperLimit"
            type="number"
            value={upperLevelLimit}
            onChange={onMaxValueChange}
            className="w-14"
            disabled={isAutoLevelingOn}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageTuning;
